export default __webpack_public_path__ + "static/media/acb6e91f08a3802b807aa49d1de9d5cb1576868406278.fad7b84a.webp";